// extracted by css-extract-rspack-plugin
export default {"exceedTooltip":"src-components-ExceedTooltip-index-module__exceedTooltip--TnqhU"};